var _classCallCheck = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/classCallCheck");

var _createClass = require("/newdisk/jisung/JS_DataStructure_Visualization/node_modules/@babel/runtime/helpers/createClass");

/*
class TreeNode:
  Data:
    key
    value
    color
    parent
    leftChild
    rightChild

  Method:
    getKey
    setKey
    getValue
    setValue
    getColor
    setColor
    getParent
    setParent
    getLeftChild
    setLeftChild
    getRightChild
    setRightChild
    getPrev
    getNext
*/

/* eslint no-use-before-define: ["error", { "variables": false }] */

/**
 * @classdesc Node of Tree.<br>
 * Use getNext and getPrev method.
 * @protected
 */
var TreeNode =
/*#__PURE__*/
function () {
  "use strict";

  /**
   * Create node of tree.
   * @constructor
   * @private
   * @param {*} key - the key of node for compare. Should not TreeNode.
   * @param {*} value - the value of node for save.
   * @param {TreeNode} parent - the parent of node in tree.
   * @param {TreeNode} leftChild - the left child of node in tree.
   * @param {TreeNode} rightChild - the right child of node in tree.
   * @param {EndNode} endnode - endnode of tree iterator.
   */
  function TreeNode() {
    var key = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : null;
    var value = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : null;
    var color = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : null;
    var parent = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
    var leftChild = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : null;
    var rightChild = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : null;
    var endnode = arguments.length > 6 && arguments[6] !== undefined ? arguments[6] : null;
    var rendnode = arguments.length > 7 && arguments[7] !== undefined ? arguments[7] : null;

    _classCallCheck(this, TreeNode);

    /**
     * all type except TreeNode.
     * @private
     * @type {*}
     */
    this._key = key;
    /**
     * @type {*}
     * @private
     */

    this._value = value;
    /**
     * only 'red' or 'black'. except case null for endnode.
    * @type {string}
    * @private
    */

    this._color = color;
    /**
     * parent node.
     * @type {TreeNode}
     * @private
     */

    this._parent = parent;
    /**
     * left child node.
     * @type {TreeNode}
     * @private
     */

    this._leftChild = leftChild;
    /**
     * right child node.
     * @type {TreeNode}
     * @private
     */

    this._rightChild = rightChild;
    /**
     * endnode
     * @type {TreeNode}
     * @private
     */

    this._endnode = endnode;
    this._rendnode = rendnode;
  }
  /**
   * Return the key of node.
   * @returns {*} - the key of node.
  */


  _createClass(TreeNode, [{
    key: "getKey",
    value: function getKey() {
      return this._key;
    }
    /** @protected */

  }, {
    key: "setKey",
    value: function setKey(key) {
      this._key = key;
    }
    /**
     * Return the value of node.
     * @returns {*} - the value of node.
    */

  }, {
    key: "getValue",
    value: function getValue() {
      return this._value;
    }
    /** @protected */

  }, {
    key: "setValue",
    value: function setValue(value) {
      this._value = value;
    }
    /**
     * Return the color of node.
     * @returns {string} - the color of node.
     * @protected
    */

  }, {
    key: "getColor",
    value: function getColor() {
      return this._color;
    }
    /** @protected */

  }, {
    key: "setColor",
    value: function setColor(color) {
      this._color = color;
    }
    /** @protected */

  }, {
    key: "getParent",
    value: function getParent() {
      return this._parent;
    }
    /** @protected */

  }, {
    key: "setParent",
    value: function setParent(node) {
      this._parent = node;
    }
    /** @protected */

  }, {
    key: "getLeftChild",
    value: function getLeftChild() {
      return this._leftChild;
    }
    /** @protected */

  }, {
    key: "setLeftChild",
    value: function setLeftChild(node) {
      this._leftChild = node;
    }
    /** @protected */

  }, {
    key: "getRightChild",
    value: function getRightChild() {
      return this._rightChild;
    }
    /** @protected */

  }, {
    key: "setRightChild",
    value: function setRightChild(node) {
      this._rightChild = node;
    }
    /*
    1. if this node has left child, go left subtree and return maximum node in there.
    2. if it has no left child, go parent.
    3. if it is right child of parent, return parent.
    4. if it is left child of parent, go next parent and go 3.
    5. but if it has no parent anymore, it is biggest node and return rendnode.
    */

    /**
     * Get prev node by the compare function.<br>
     * At rendnode, it returns false.
     * @returns {TreeNode} - the prev node.
     */

  }, {
    key: "getPrev",
    value: function getPrev() {
      if (this.getColor() === null) {
        return false;
      }

      var leftmax = findLeftMaximum(this);

      if (leftmax === this) {
        var nownode = this;
        var p = parent(this);

        while (p !== null && p.getRightChild() !== nownode) {
          nownode = p;
          p = parent(p);
        }

        if (p !== null) {
          return p;
        }

        return this._rendnode;
      }

      return leftmax;
    }
    /*
    1. if this node has right child, go right subtree and return minimum node in there.
    2. if it has no right child, go parent.
    3. if it is left child of parent, return parent.
    4. if it is right child of parent, go next parent and go 3.
    5. but if it has no parent anymore, it is biggest node and return endnode.
    */

    /**
     * Get next node by the compare function.<br>
     * At endnode, it returns false.
     * @returns {false|TreeNode} - the next node.
     */

  }, {
    key: "getNext",
    value: function getNext() {
      if (this.getColor() === null) {
        return false;
      }

      var rightmin = findRightMinimum(this);

      if (rightmin === this) {
        var nownode = this;
        var p = parent(this);

        while (p !== null && p.getLeftChild() !== nownode) {
          nownode = p;
          p = parent(p);
        }

        if (p !== null) {
          return p;
        }

        return this._endnode;
      }

      return rightmin;
    }
  }]);

  return TreeNode;
}();
/**
 * get parent of node.
 * @param {TreeNode} node
 * @returns {null|Treenode}
 * @private
 */


var parent = function parent(node) {
  if (!(node instanceof TreeNode)) {
    return null;
  }

  return node.getParent();
};
/**
 * find the left maximum node of given node.
 * @param {TreeNode} node
 * @returns {null|TreeNode}
 * @private
 */


var findLeftMaximum = function findLeftMaximum(node) {
  if (node === null) {
    return null;
  }

  var leftmax = node.getLeftChild();

  if (leftmax.getLeftChild() === null) {
    return node;
  } // check leaf


  while (leftmax.getRightChild().getLeftChild() !== null) {
    leftmax = leftmax.getRightChild();
  }

  return leftmax;
};
/**
 * find the right minimum node of given node.
 * @param {TreeNode} node
 * @returns {null|TreeNode}
 * @private
 */


var findRightMinimum = function findRightMinimum(node) {
  if (node === null) {
    return null;
  }

  var rightmin = node.getRightChild();

  if (rightmin.getLeftChild() === null) {
    return node;
  } // check leaf


  while (rightmin.getLeftChild().getLeftChild() !== null) {
    rightmin = rightmin.getLeftChild();
  }

  return rightmin;
};

module.exports = TreeNode;